import {React, useHistory, useContext} from 'external/react'
import {Chip} from 'external/material'

import {TeacherContext} from 'teacher/context'

export default function FilterChip(props) {

  const history = useHistory()
  const context = useContext(TeacherContext)
  const {name, createLabel = a => a, path} = props
  const label = createLabel(context.query[name])

  function handleDelete () {
    history.push(context.linkQuery(path, {...context.query, [name]: undefined}))
  }

  return (<Chip label={label} onDelete={handleDelete} className="filter-chip" />)
}

